// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1IgC2","buttons":"Footer_buttons__29Z9U"};